import React from "react";
import CheckIcon from "/Images/cekidot.svg"; // Checklist icon
import DeployImage from "/Images/custody1.svg"; // Gambar deployment
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Ikon panah dari Material UI
import { useMediaQuery } from "@mui/material"; // Import media query hook

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query untuk cek layar mobile

  // Style responsif berdasarkan isMobile
  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Kolom untuk mobile, row untuk desktop
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E7E4E2",
      padding: isMobile ? "50px 20px" : "100px", // Padding lebih kecil di mobile
      borderRadius: "10px",
      textAlign: isMobile ? "center" : "left",
    },
    paragraph: {
      color: "#6D6D6D",
      fontSize: isMobile ? "0.875rem" : "1rem", // Ukuran font lebih kecil di mobile
      lineHeight: "1.6",
      marginBottom: "20px",
      textAlign: "justify", // Justifikasi teks
    },
    textContainer: {
      width: isMobile ? "100%" : "45%", // Full width di mobile
      paddingRight: isMobile ? "0" : "20px",
      marginBottom: isMobile ? "20px" : "0", // Spasi di bawah pada mobile
    },
    imageContainer: {
      width: isMobile ? "100%" : "50%", // Full width untuk mobile
      display: "flex",
      justifyContent: "center",
      marginBottom: isMobile ? "20px" : "0", // Spasi di bawah gambar pada mobile
    },
    image: {
      width: isMobile ? "80%" : "574px", // Adjust image width for mobile
      maxWidth: isMobile? "400px" :"574px",
      borderRadius: "10px",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "24px" : "32px", // Ukuran font lebih kecil di mobile
      fontWeight: "600",
      marginBottom: "20px",
    },
    subheading: {
      color: "#214D73",
      fontSize: isMobile ? "18px" : "1.5rem",
      marginBottom: "10px",
    },
    listItem: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
      color: "#6D6D6D",
      justifyContent: isMobile ? "center" : "flex-start", // Pusatkan di mobile
    },
    listIcon: {
      width: isMobile ? "15px" : "20px", // Ukuran ikon lebih kecil di mobile
      height: isMobile ? "15px" : "20px",
      marginRight: "10px",
    },
    exploreMore: {
      color: "#B0990D",
      fontSize: isMobile ? "0.875rem" : "1rem", // Font lebih kecil di mobile
      textDecoration: "underline",
      display: "flex",
      alignItems: "center",
      justifyContent: isMobile ? "center" : "flex-start", // Pusatkan di mobile
      marginTop: "20px",
      cursor: "pointer", // Menambahkan efek kursor
    },
    arrow: {
      marginLeft: "10px", // Jarak antara teks dan panah
      backgroundColor: "#2D669B", // Warna lingkaran
      borderRadius: "50%",
      padding: "5px", // Jarak dalam lingkaran
      color: "#F4E37B", // Warna panah
    },
  };

  return (
    <div style={styles.container}>
      {/* Conditional rendering: Gambar di atas konten pada tampilan mobile */}
      {isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Innovative Security Solutions to 
          Protect Your Digital Assets
        </h2>
        <p style={styles.paragraph}>
          As new technologies bring exciting opportunities, they also present
          unique challenges that demand innovative solutions. We rise to this
          challenge with our next-generation digital custody solution. We
          utilize a comprehensive Defense-in-Depth approach, featuring a cold
          wallet setup secured by FIPS 140-2 Level 3 Hardware Security Modules
          (HSMs). We also certified global standards with ISO 27001:2022 and ISO
          27701:2019 certifications as a Depository Storage provider in
          Indonesia.
        </p>

        {/* Explore More Link */}
        <div style={styles.exploreMore}>
          Explore more
          <ArrowForwardIcon style={styles.arrow} />
        </div>
      </div>
      {/* Render the image on the side for desktop */}
      {!isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
    </div>
  );
};

export default DeploymentSection;
